import React from "react";
import { XCircle } from "lucide-react";

interface RejectModalProps {
    isOpen: boolean;
    onClose: () => void;
    onReject: () => void;
    requestUser?: string; // optional, show user/package info
}

const RejectPackageModal: React.FC<RejectModalProps> = ({
    isOpen,
    onClose,
    onReject,
    requestUser,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4 z-50">
            <div className="bg-white text-black rounded-lg shadow-lg w-full max-w-md p-6 relative">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl"
                >
                    &times;
                </button>

                {/* Header */}
                <div className="flex items-center gap-2 mb-4 justify-center">
                    <XCircle size={24} className="text-red-600" />
                    <h2 className="text-lg font-semibold text-center font-urbanist">
                        Reject Request
                    </h2>
                </div>

                {/* Body */}
                <p className="text-gray-600 text-center mb-6">
                    Are you sure you want to reject this request{" "}
                    <span className="font-medium text-gray-800">{requestUser || ""}</span>?
                </p>

                {/* Buttons */}
                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onReject}
                        className="px-4 py-2 rounded-lg text-white"
                        style={{
                            background: "linear-gradient(360deg, #dc2626 0%, #ef4444 100%)",
                        }}
                    >
                        Reject
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RejectPackageModal;
